import { defineComponent as _defineComponent } from 'vue'
import { uniqueId } from '@/utils/misc';
import { Subsidiary } from '@/models/subsidiary';
import { subsidiariesService } from '@/services/subsidiaries.service';
import { useI18n } from '@/composables/i18n';
import { computed, onMounted, reactive, ref, watch } from 'vue';
import { ValidationRules } from '@/utils/validation';
import useVuelidate from '@vuelidate/core';


export default /*#__PURE__*/_defineComponent({
  __name: 'SubsidiariesTagInput',
  props: {
    value: { default: () => [] },
    disabled: { type: Boolean, default: false },
    showLabel: { type: Boolean, default: true },
    validationRules: { default: () => ({}) }
  },
  emits: ["input", "blur"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', value: Subsidiary[]): void;
  (e: 'blur'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: Subsidiary[], disabled: boolean, showLabel: boolean, validationRules: ValidationRules };





const availableSubsidiaries = ref<Subsidiary[]>([]);
const typingText = ref<string>('');
const isLoading = ref(false);

const { t } = useI18n();
const componentId = uniqueId();

const state = reactive({
  selectedSubsidiaries: props.value,
});
const validations = {
  selectedSubsidiaries: props.validationRules,
};
const v$ = useVuelidate(validations, state);

onMounted(async () => {
  await loadData();
});

async function loadData() {
  isLoading.value = true;
  availableSubsidiaries.value = await subsidiariesService
    .get()
    .finally(() => (isLoading.value = false));
}

function selectAll() {
  state.selectedSubsidiaries = [...availableSubsidiaries.value];
  emitSelectedSubsidiaries();
  emitBlur();
  v$.value.selectedSubsidiaries.$touch();
}

function clearAll() {
  state.selectedSubsidiaries = [];
  emitSelectedSubsidiaries();
  emitBlur();
  v$.value.selectedSubsidiaries.$touch();
}

function emitSelectedSubsidiaries() {
  emit('input', state.selectedSubsidiaries);
}

function onTaginputBlur() {
  emitBlur();
  // Without the timeout, the touch() is called before the prop value is updated.
  // This causes the validation error to flash for a few milliseconds. The timeout prevents it.
  setTimeout(() => {
    v$.value.selectedSubsidiaries.$touch();
  }, 100);
}

function emitBlur() {
  emit('blur');
}

const label = computed((): string | undefined => {
  if (!props.showLabel) {
    return undefined;
  }

  return t('inputs.alerts_subsidiary_select.label').toString();
});

const nonSelectedSubsidiaries = computed(() =>
  availableSubsidiaries.value
    .filter(
      (subsidiary) =>
        !state.selectedSubsidiaries.some(
          (selected) => selected.id === subsidiary.id,
        ),
    )
    .filter((subsidiary) =>
      subsidiary.name.toLowerCase().includes(typingText.value.toLowerCase()),
    ),
);

const required = computed(() => 'required' in props.validationRules);

const validationMessage = computed(
  () => v$.value.selectedSubsidiaries.$errors[0]?.$message,
);

return { __sfc: true,props, emit, availableSubsidiaries, typingText, isLoading, t, componentId, state, validations, v$, loadData, selectAll, clearAll, emitSelectedSubsidiaries, onTaginputBlur, emitBlur, label, nonSelectedSubsidiaries, required, validationMessage }
}

})